import { InMemoryProvider, OpenFeature } from "@openfeature/web-sdk";

import type {
  FeatureFlagConfiguration,
  OpenFeatureFlagConfiguration,
} from "./client";

function setupTestFlags(flags: FeatureFlagConfiguration) {
  OpenFeature.setProvider(
    new InMemoryProvider(flags as OpenFeatureFlagConfiguration)
  );
}

function resetTestFlags() {
  OpenFeature.setProvider(new InMemoryProvider({}));
}

function setupTestFlag<T>(flagConfig: T, variant: string): void {
  const modifiedConfig = Object.assign(
    {},
    flagConfig
  ) as FeatureFlagConfiguration;

  // Update the defaultVariant for each flag in the config
  for (const key in modifiedConfig) {
    if (Object.hasOwn(modifiedConfig, key)) {
      const flag = modifiedConfig[key];
      if ("defaultVariant" in flag) {
        modifiedConfig[key] = {
          ...flag,
          defaultVariant: variant,
        };
      }
    }
  }

  setupTestFlags(modifiedConfig);
}

export { setupTestFlags, resetTestFlags, setupTestFlag };
